
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getMainworkorderstatus} from 'sr/utils/api/masterData/mainworkorderstatus/getMainworkorderstatus'
export const fetchmainworkorderstatus = createAsyncThunk(
  'getMainworkorderstatus',
  async () => {
    const response = await getMainworkorderstatus()
    return response?.data
  }
)


